<template>
  <speech-recognition :locale="locale" :language="language" ref="recognition"/>
</template>

<script>
import { defineComponent, inject, getCurrentInstance } from 'vue'
import SpeechRecognition from './SpeechRecognition.vue';

export default defineComponent({
  components: {
    SpeechRecognition 
  },
  setup(){
    const root = getCurrentInstance();
    let language = inject('language');
    let locale = inject('hl');

    const stop = () => {
      root.proxy.$refs.recognition.stop();
    }

    return {
      language,
      stop,
      locale
    }
  },
})
</script>

